import {ClientAddress} from "@common-core/coat-operational-hierarchy-appsync-model";
import {
  ClientEntityReference,
  PrimaryClientAddress
} from "./PrimaryClientAddress";

/**
 * The {@link toPrimaryClientAddress} is a high-order function that returns a
 * mapping function capable of converting a {@link ClientAddress} into a
 * {@link PrimaryClientAddress} for display.
 *
 * @param entity A reference to the client entity to which the address belongs.
 */
export const toPrimaryClientAddress =
  (entity: ClientEntityReference) =>
  (address: ClientAddress): PrimaryClientAddress => ({
    // Currently we are presenting only one address per client entity,
    // so the key for this view model can be the client entity id.
    key: entity.caId,
    entity,
    address
  });
